const state = () => ({
  isValid: false,
  companyName: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  companyName(state) {
    return state.companyName;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateCompanyName(state, payload) {
    state.companyName = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  updateCompanyName({ commit }, payload) {
    commit('updateCompanyName', payload);
  }
};

export const companyName = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
